import { actionTypes, UserEntersEmail } from "./Actions";

const userEntersEmail: UserEntersEmail = email => ({
  email,
  type: actionTypes.USER_ENTERS_EMAIL
});

export default userEntersEmail;
